<ng-template #layoutComponentRef/>
